import React from 'react'
import cn from 'classnames';

import Styles from './index.module.scss'

type shapeStyle = 'square' | 'circle'

interface ShapeProps {
	color: string,
	shapeStyle: shapeStyle,
	props?: any
}

const Shape: React.FC<ShapeProps> = ({ color, shapeStyle, props }) => {
	const getShapeStyle = (): string => {
		switch (shapeStyle) {
			case 'circle':
				return Styles.circle;
			case 'square':
				return Styles.square
		}
	}

	return (
		<div className={cn(getShapeStyle())} style={{ backgroundColor: color }}>
		</div>
	)
}
export default Shape